import { Icon as BlueIcon } from '@blueprintjs/core';
import { useEffect, useRef, useState } from 'react';
import { ClickAwayListener } from '@material-ui/core';

import {
  Container,
  Input,
  InputContainer,
  SearchIcon,
  SearchButton,
} from './Search.styles';

interface ISearch {
  loadSearch: (str: string) => void;
  helperText: string;
}

export const Search = ({ loadSearch, helperText }: ISearch) => {
  const inputRef = useRef<any>(null);

  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [searched, setSearched] = useState(false);

  const submit = () => {
    if (search) {
      setSearched(true);
      loadSearch(search);
    }
  };

  const clean = () => {
    setSearched(false);
    setSearch('');
    loadSearch('');
  };

  const handleClickAway = () => {
    if (!search && !searched) {
      setOpen(false);
    }
  };

  useEffect(() => {
    if (open) {
      inputRef.current.focus();
    }
  }, [open]);

  return (
    <Container>
      <SearchIcon>
        <BlueIcon
          icon="search"
          color="#8F95B2"
          onClick={() => {
            if (open) {
              if (!search && !searched) {
                setOpen(false);
              }
            } else {
              setOpen(true);
            }
          }}
        />
      </SearchIcon>
      {open && (
        <ClickAwayListener onClickAway={handleClickAway}>
          <InputContainer>
            <Input
              ref={inputRef}
              searched={searched}
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder={helperText}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  submit();
                }

                if (e.key === 'Escape') {
                  clean();
                  setOpen(false);
                }
              }}
            />
            {searched ? (
              <SearchButton>
                <SearchIcon onClick={clean}>
                  <BlueIcon icon="cross" color="#8F95B2" />
                </SearchIcon>
              </SearchButton>
            ) : (
              <SearchButton onClick={submit}>Search</SearchButton>
            )}
          </InputContainer>
        </ClickAwayListener>
      )}
    </Container>
  );
};
